<template>
  <!-- eslint-disable vue/max-attributes-per-line, vue/v-bind-style -->
  <svg :viewBox="computedViewBox" class="Icon" :class="classes">
    <g :id="iconId">
      <g class="Icon-color">
        <use :class="iconId" v-bind:href="iconHref" />
      </g>
      <g v-if="hasTexture" class="Icon-texture">
        <use :class="iconId" v-bind:href="iconHref" />
      </g>
    </g>
  </svg>
</template>

<script>
import symbols from "@icons/symbols.svg";

export default {
  props: {
    classes: {
      type: [Array, Object, String],
      default: "",
    },

    hasTexture: {
      type: [Boolean, Number],
      default: false,
    },

    iconName: {
      type: String,
      required: true,
    },

    iconSuffix: {
      type: String,
      default: "",
    },

    requiresStroke: {
      type: [Boolean, Number],
      default: false,
    },

    viewBox: {
      type: String,
      default: "0 0 24 24",
    },
  },

  computed: {
    computedViewBox() {
      let computedViewBox = this.viewBox;

      if (this.requiresStroke) {
        computedViewBox = computedViewBox
          .split(" ")
          .map((el, index) => {
            if (index < 1) {
              el = el - 1;
            } else {
              el = el + 2;
            }
            return el;
          })
          .join(" ");
      }

      return computedViewBox;
    },

    iconHref() {
      return `${symbols}#Icon-${this.iconName}Template${this.suffix}`;
    },

    iconId() {
      return `Icon-${this.iconName}${this.suffix}`;
    },

    suffix() {
      return this.iconSuffix ? `--${this.iconSuffix}` : "";
    },
  },
};
</script>
